export default "__VITE_ASSET__fxONIRJh__"